import { ThemeProvider } from '@material-ui/core';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import React from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './index.css';
import theme from './providers/theme-service';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: "https://1fbb19ed02ce4bd6acdbb31dda635d6e@o316139.ingest.sentry.io/6085608",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 0.1 to capture 10%
  // of transactions for performance monitoring.
  // Reduced from 1.0 to prevent performance issues
  tracesSampleRate: 0.1,
  
  // Only enable Sentry in production/staging environments
  enabled: process.env.NODE_ENV === 'production' || process.env.REACT_APP_STAGE === 'staging',
  
  // Ignore certain errors that might break the page
  ignoreErrors: [
    // Browser extensions
    'top.GLOBALS',
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    'atomicFindClose',
    'fb_xd_fragment',
    'bmi_SafeAddOnload',
    'EBCallBackMessageReceived',
    'conduitPage',
    // Network errors that shouldn't break the app
    'NetworkError',
    'Failed to fetch',
    'Network request failed',
  ],
  
  // Don't send errors from localhost in development
  beforeSend(event, hint) {
    if (process.env.NODE_ENV === 'development') {
      return null;
    }
    return event;
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
      <ToastContainer />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
